// ─── Milk design-system palette ──────────────────────────────────────────────
// Granola-inspired light theme. Shared across Onboarding, Capture, Shared-with-me,
// Contact detail and the public Shared Action Card page.

export const BLUE = '#6796C2';        // primary accent
export const BLUE_D = '#4C73A6';      // accent (text / hover)
export const INK = '#212E40';         // primary text
export const MUTE = '#6F6E67';        // secondary text
export const FAINT = '#9A988F';       // tertiary / placeholder text
export const LINE = 'rgba(33,46,64,.14)'; // hairline borders
export const CREAM = '#F4F2EB';       // app / page background
export const CARD_ALT = '#FBFAF6';    // subtle alt surface (inputs, rows)
export const GREEN = 'hsl(142,52%,34%)'; // success / done

export const SERIF = "'Instrument Serif', Georgia, serif";
export const SANS = "'Work Sans', sans-serif";

export const WORDMARK_BLUE = '/assets/logos/wordmark-blue.png';
